import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import Box from '../box/box.jsx';
import styles from './connection-modal.css';

const Dots = props => (
    <Box
        className={classNames(
            props.className,
            styles.dotsRow
        )}
    >
        <div
            className={classNames(
                styles.dotsHolder,
                {
                    [styles.dotsHolderError]: props.error,
                    [styles.dotsHolderSuccess]: props.success,
                    [styles.dotsHolderTransparent]: props.transparent
                }
            )}
        >
            {Array(props.total).fill(0)
                .map((_, i) => {
                    let type = 'inactive';
                    if (props.counter === i) type = 'active';
                    if (props.bouncing) type = 'active';
                    if (props.success) type = 'success';
                    if (props.error) type = 'error';
                    return (<Dot
                        key={`dot-${i}`}
                        type={type}
                        bouncing={props.bouncing}
                        style={props.bouncing ? {animationDelay: `${i * 0.1}s`} : {}}
                    />);
                })}
        </div>
    </Box>
);

Dots.propTypes = {
    className: PropTypes.string,
    counter: PropTypes.number,
    error: PropTypes.bool,
    success: PropTypes.bool,
    total: PropTypes.number,
    bouncing: PropTypes.bool,
    transparent: PropTypes.bool
};

const Dot = props => (
    <div
        style={props.style}
        className={classNames(
            styles.dot,
            {
                [styles.inactiveStepDot]: props.type === 'inactive',
                [styles.activeStepDot]: props.type === 'active',
                [styles.successDot]: props.type === 'success',
                [styles.errorDot]: props.type === 'error',
                [styles.dotBouncing]: props.bouncing
            }
        )}
    />
);

Dot.propTypes = {
    type: PropTypes.string,
    bouncing: PropTypes.bool,
    style: PropTypes.object
};

export default Dots;
